import script from "./AccountContent.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountContent.vue?vue&type=script&setup=true&lang=js"

import "./AccountContent.vue?vue&type=style&index=0&id=dfeb0766&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfeb0766"]])

export default __exports__